// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { previousSunday as fn } from "../previousSunday.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const previousSundayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default previousSundayWithOptions;
